import { Trans } from '@lyearn/i18n';
import { AddMenuScorm, FolderOutline } from '@lyearn/icons';
import { addMenuItemType, createReactExtension, PerformanceType } from '@lyearn/lygo-core';

const scormExtension = createReactExtension({
  name: 'ly__scorm',
  attrs: {
    scormId: {
      default: null,
    },
    width: {
      default: 52.63,
    },
    height: {
      default: 0,
    },
  },
  Component: (props) => {
    const { attrs, ...rest } = props;
    const Component =
      require('@/modules/corporate/modules/course/components/ScormCardContainer').default;
    return <Component {...attrs} {...rest} />;
  },
  menuItem: [
    {
      name: 'ly__scorm',
      title: <Trans i18nKey="Scorm:Scorm" />,
      icon: FolderOutline,
      addMenuIcon: AddMenuScorm,
      addMenuItemType: addMenuItemType.contents,
      description: <Trans i18nKey="Scorm:Editor.ScormBlockAddDescription" />,
      searchWords: ['scorm'],
    },
  ],
  performanceType: PerformanceType.BLOCK_BASED,
});

export default scormExtension;
